/* Roadbook Guides: filters, sort, quiz, gallery, sticky buy bar */
(function () {
  'use strict';

  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Filter chips (homepage grid + collection) ---------- */
  function setupFilter(group) {
    var grid = document.getElementById(group.getAttribute('data-rb-filter'));
    if (!grid || group.dataset.rbReady) return;
    group.dataset.rbReady = '1';
    var chips = $all('.rb-chip[data-value]', group);
    var section = group.closest('section') || document;
    var empty = section.querySelector('[data-rb-empty]');
    var count = section.querySelector('[data-rb-count]');
    var useUrl = group.hasAttribute('data-rb-url');

    function apply(value, push) {
      var shown = 0;
      $all('.rb-card', grid).forEach(function (card) {
        var ok = value === 'all' ||
          (value === 'packs' ? card.getAttribute('data-pack') === 'true' : card.getAttribute('data-cat') === value);
        card.hidden = !ok;
        if (ok) shown++;
      });
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-value') === value ? 'true' : 'false'); });
      if (empty) empty.hidden = shown !== 0;
      if (count) {
        var tpl = shown === 1 ? count.getAttribute('data-one') : count.getAttribute('data-other');
        if (tpl) count.textContent = tpl.replace(/\d+/, String(shown));
      }
      if (useUrl && push) {
        try {
          var url = new URL(window.location.href);
          if (value === 'all') url.searchParams.delete('cat'); else url.searchParams.set('cat', value);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () { apply(chip.getAttribute('data-value'), true); });
    });

    var initial = 'all';
    try { initial = new URL(window.location.href).searchParams.get('cat') || 'all'; } catch (e) {}
    if (useUrl && initial !== 'all' && chips.some(function (c) { return c.getAttribute('data-value') === initial; })) {
      apply(initial, false);
    }
  }

  /* ---------- Client-side sort ---------- */
  function setupSort(select) {
    var grid = document.getElementById(select.getAttribute('data-rb-sort'));
    if (!grid || select.dataset.rbReady) return;
    select.dataset.rbReady = '1';
    var cards = $all('.rb-card', grid);
    cards.forEach(function (c, i) { c.dataset.order = i; });
    select.addEventListener('change', function () {
      var v = select.value;
      var sorted = cards.slice().sort(function (a, b) {
        if (v === 'asc') return (+a.dataset.price) - (+b.dataset.price);
        if (v === 'desc') return (+b.dataset.price) - (+a.dataset.price);
        return (+a.dataset.order) - (+b.dataset.order);
      });
      sorted.forEach(function (c) { grid.appendChild(c); });
    });
  }

  /* ---------- Quiz ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }

  function setupQuiz(root) {
    if (root.dataset.rbReady) return;
    root.dataset.rbReady = '1';
    var data = [], i18n = {};
    try { data = JSON.parse(root.querySelector('[data-rb-catalog]').textContent); } catch (e) { data = []; }
    try { i18n = JSON.parse(root.querySelector('[data-rb-i18n]').textContent); } catch (e) {}
    var steps = $all('[data-step]', root);
    var bar = root.querySelector('.rb-quiz__bar i');
    var opts = root.querySelector('[data-opts]');
    var result = root.querySelector('[data-result]');
    var history = [];
    var currentCat = null;

    function show(n) {
      steps.forEach(function (s) { s.hidden = s.getAttribute('data-step') !== String(n); });
      if (bar) bar.style.width = (n === 1 ? 15 : n === 2 ? 55 : 100) + '%';
    }

    $all('.rb-quiz__opt[data-cat]', root).forEach(function (btn) {
      var cat = btn.getAttribute('data-cat');
      if (!data.some(function (p) { return p.cat === cat; })) btn.hidden = true;
      btn.addEventListener('click', function () {
        currentCat = cat;
        var guides = data.filter(function (p) { return p.cat === cat && !p.pack; });
        if (guides.length === 1) { renderResult(guides[0]); history = [1]; show(3); return; }
        opts.innerHTML = guides.map(function (p, i) {
          return '<button type="button" class="rb-quiz__opt" data-i="' + i + '"><span aria-hidden="true">' + esc(p.emoji) + '</span>' + esc(p.sit) + '</button>';
        }).join('');
        $all('[data-i]', opts).forEach(function (b) {
          b.addEventListener('click', function () { renderResult(guides[+b.getAttribute('data-i')]); history = [1, 2]; show(3); });
        });
        history = [1];
        show(2);
        var first = opts.querySelector('button'); if (first) first.focus({ preventScroll: true });
      });
    });

    function renderResult(p) {
      var packs = data.filter(function (x) { return x.cat === currentCat && x.pack; });
      var html = '<div class="rb-quiz__result">' +
        (p.img ? '<a href="' + esc(p.url) + '" tabindex="-1"><img src="' + esc(p.img) + '" alt="" width="200" height="200" loading="lazy"></a>' : '<span></span>') +
        '<div><h4>' + esc(p.title) + '</h4><p>' + esc(p.ben) + '</p>' +
        '<a class="rb-btn rb-btn--sm" href="' + esc(p.url) + '">' + esc(i18n.see || 'Voir') + ' · ' + esc(p.price) + '</a></div></div>';
      if (packs.length) {
        html += '<p class="rb-quiz__more">' + esc(i18n.packs_hint || '') + ' ' + packs.map(function (k) {
          return '<a href="' + esc(k.url) + '">' + esc(k.title) + ' (' + esc(k.price) + ')</a>';
        }).join(' · ') + '</p>';
      }
      result.innerHTML = html;
    }

    $all('[data-back]', root).forEach(function (b) {
      b.addEventListener('click', function () { var prev = history.pop() || 1; show(prev); });
    });
    $all('[data-restart]', root).forEach(function (b) {
      b.addEventListener('click', function () { history = []; show(1); });
    });
    show(1);
  }

  /* ---------- Product gallery ---------- */
  function setupGallery(root) {
    if (root.dataset.rbReady) return;
    root.dataset.rbReady = '1';
    var track = root.querySelector('[data-track]');
    var thumbs = $all('.rb-gallery__thumb', root);
    if (!track || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.getAttribute('data-index');
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      });
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      });
    });
  }

  /* ---------- Sticky buy bar (mobile) ---------- */
  function setupSticky() {
    var bar = document.querySelector('[data-rb-sticky]');
    var buy = document.querySelector('[data-rb-buy]');
    if (!bar || !buy || !('IntersectionObserver' in window) || bar.dataset.rbReady) return;
    bar.dataset.rbReady = '1';
    var btn = bar.querySelector('button');
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      if (btn) btn.tabIndex = past ? 0 : -1;
    }).observe(buy);
  }


  /* ---------- Hero roadbook: tabs + one draw on first view ---------- */
  function setupRoadbook(root) {
    if (root.dataset.rbReady) return;
    root.dataset.rbReady = '1';
    var tabs = $all('[data-rbk-tab]', root);
    var panels = $all('[data-rbk-panel]', root);
    function draw() {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.remove('is-drawing'); void root.offsetWidth; root.classList.add('is-drawing');
      clearTimeout(root._rbkT); root._rbkT = setTimeout(function () { root.classList.remove('is-drawing'); }, 1800);
    }
    tabs.forEach(function (b) {
      b.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        panels.forEach(function (x) { x.hidden = x.getAttribute('data-rbk-panel') !== b.getAttribute('data-rbk-tab'); });
        draw();
      });
    });
    draw();
  }

  function init() {
    $all('[data-rb-filter]').forEach(setupFilter);
    $all('[data-rb-sort]').forEach(setupSort);
    $all('[data-rb-quiz]').forEach(setupQuiz);
    $all('[data-rb-gallery]').forEach(setupGallery);
    $all('[data-rbk]').forEach(setupRoadbook);
    setupSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
